import PtoNavigator from './PtoNavigator'

export default PtoNavigator
